import React from "react";
import { Users, Shield } from "lucide-react";

interface UserManagementHeaderProps {
  activeTab: string;
  onTabChange: (tab: "users" | "roles") => void;
}

export const UserManagementHeader: React.FC<UserManagementHeaderProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <div className="flex border-b border-cardborder mb-8 flex-col md:flex-row md:items-center md:justify-between max-w-7xl mx-auto px-8 py-8">
      <div className="flex items-center h-10">
        <h2 className="text-2xl font-bold text-gray-900">User Management</h2>
      </div>
      <div className="flex items-center h-10 gap-3">
        <button
          onClick={() => onTabChange("users")}
          className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            activeTab === "users"
              ? "text-white bg-brand"
              : "text-gray-600 bg-gray-100 hover:bg-gray-200"
          }`}
        >
          <Users className="w-4 h-4 inline mr-2" />
          Users
        </button>
        <button
          onClick={() => onTabChange("roles")}
          className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            activeTab === "roles"
              ? "text-white bg-brand"
              : "text-gray-600 bg-gray-100 hover:bg-gray-200"
          }`}
        >
          <Shield className="w-4 h-4 inline mr-2" />
          Roles & Permissions
        </button>
      </div>
    </div>
  );
};
